/**
 * La lettre de chaque ville.
 *
 * Le nom du spot en tete du feed ne s'ecrit pas dans la police de
 * l'application mais dans la sienne. Le texte reste francais partout —
 * c'est le dessin des lettres qui change, pas la langue.
 *
 * Trois textures franchement differentes, c'est la seule regle : deux
 * serifs elegants cote a cote ne disent rien, on les prend pour la meme.
 *
 *   Marrakech  Reem Kufi        une geometrie tiree du kufique, qui
 *                               rappelle le trace des zelliges.
 *   Londres    Playfair Display l'anglaise victorienne des enseignes et
 *                               des journaux.
 *   Barcelone  Yeseva One       les courbes organiques de l'art nouveau,
 *                               qui est le modernisme catalan.
 *   Berlin     Archivo Black    une grotesque industrielle, la lettre des
 *                               affiches et de la signaletique.
 *
 * Barcelone a d'abord porte Poiret One, plus franchement art nouveau
 * mais filiforme : a cote de deux titres pleins, elle ne faisait pas
 * poids et la rangee paraissait bancale. Yeseva garde les courbes en
 * reprenant la masse des deux autres.
 *
 * Une ville absente d'ici garde la police de l'application : c'est le
 * repli, et il ne casse rien. Il joue aussi quand le reseau manque, les
 * polices etant servies par Google Fonts comme celle de l'application.
 *
 * Ouvrir une ville avec sa propre lettre demande donc deux gestes : une
 * entree ici, et sa famille ajoutee au lien de `index.html`.
 */
export interface PoliceDeVille {
  /** La famille, telle qu'elle est chargee. */
  famille: string;
  /** Les faces d'affichage n'ont pas toutes de gras : on dit laquelle. */
  graisse: number;
  /** Corrige l'espacement quand le dessin le demande. */
  interlettre?: string;
}

export const POLICES_DE_VILLE: Record<string, PoliceDeVille> = {
  marrakech: { famille: "'Reem Kufi'", graisse: 700 },
  londres: { famille: "'Playfair Display'", graisse: 700, interlettre: '-0.01em' },
  barcelone: { famille: "'Yeseva One'", graisse: 400 },
  berlin: { famille: "'Archivo Black'", graisse: 400, interlettre: '-0.02em' },
  /*
    Paris  Limelight  l'Art deco des enseignes de cabaret et des
                       marquises de theatre — une texture pleine, sans
                       parente avec les deux serifs deja pris.
  */
  paris: { famille: "'Limelight'", graisse: 400, interlettre: '0.01em' },
  /*
    ESSEC  Cinzel  les capitales romaines du logo grave sur la tour.

    Le logo de l'ecole est une romaine classique — empattements fins et
    triangulaires, fort contraste entre pleins et delies, proportions de
    l'inscription latine. Cinzel est dessinee sur ces memes modeles, et
    c'est la plus proche que l'on puisse servir librement : Helvetica,
    essayee avant, ne se distribue pas en police web, et ne disait rien
    de l'ecusson.

    Elle voisine avec la Playfair de Londres, ce qui contredit la regle
    des trois textures : celle-ci sert un logo existant, pas une humeur
    de ville, et les deux serifs ne se croisent jamais dans le meme
    ecran.
  */
  essec: { famille: "'Cinzel'", graisse: 700, interlettre: '0.02em' },
  /*
    Poissy  Uncial Antiqua  l'onciale des manuscrits, pour la ville ou est
                            ne Saint Louis et la collegiale ou il fut
                            baptise. Une texture qu'aucune autre ville ne
                            porte : ni kufi, ni serif, ni grotesque.
  */
  poissy: { famille: "'Uncial Antiqua'", graisse: 400 },
};
